import { useCustomFields } from '../admin/custom-field-data.ts'
import {
  CampoInput,
  camposDoGrupo,
  filtrarVisiveis,
  rotuloCampo,
  useCustomValues,
  type ItemParaRegras,
} from './campos-shared.tsx'
import { CampoInfo } from './CampoInfo.tsx'

/**
 * Campos complementares da BARRA DE PROPRIEDADES (colocação sem grupo) —
 * renderizados dentro do painel lateral "Propriedades", como as demais
 * propriedades do item (SPEC-20260828-1914). Grava no JSONB `customValues`.
 */

export function CamposComplementaresProps({
  workItemId,
  workItemTypeId,
  customValues,
  fieldHelp,
  item,
}: {
  workItemId: string
  workItemTypeId: string
  customValues: Record<string, unknown>
  /** Instrucoes personalizadas do item ({ chave: html }) — para o "i". */
  fieldHelp?: Record<string, string>
  item: ItemParaRegras
}) {
  // sem filtro por tipo (ver CamposComplementaresItem): colocação + condições
  const dados = useCustomFields('work_item')
  const { valores, setValores, gravar } = useCustomValues(workItemId, customValues)

  const campos = (dados.data?.fields ?? []).filter((f) => f.defaultVisible)
  const placements = dados.data?.placements ?? []
  const daBarra = filtrarVisiveis(camposDoGrupo(campos, placements, null), item, valores)
  if (daBarra.length === 0) return null

  return (
    <>
      {daBarra.map(({ campo: f }) => (
        <div key={f.id}>
          <span className="wi-prop__label">
            {rotuloCampo(f.labels, f.key)}
            {f.required ? <span className="wi-cf__obrig"> *</span> : null}
            <CampoInfo
              chave={f.key}
              titulo={rotuloCampo(f.labels, f.key)}
              ajudaPadrao={typeof f.config.help === 'string' ? f.config.help : null}
              workItemId={workItemId}
              fieldHelp={fieldHelp}
            />
          </span>
          <div className="wi-prop__cf">
            <CampoInput f={f} valores={valores} setValores={setValores} gravar={gravar} escopo={workItemId} />
          </div>
        </div>
      ))}
    </>
  )
}
